import { Button, Stack } from '@optimus-web/core';
import { FloatingPanel } from '@mews/b2b-ui';
import { TextKey } from '@mews-commander/enums';
import { lt } from '@mews/framework';
import { EmailWhitelistConfiguration, EmailWhitelistUserData } from '@mews-commander/data-access';
import { useWhitelistedUserEmailForm } from './useWhitelistedUserEmailForm';
import { EmailSelectField } from './fields/EmailSelectField';
import { EmailTypesSelectField } from './fields/EmailTypesSelectField';

interface WhitelistedUserEmailDialogProps {
    active: boolean;
    selectedRow: EmailWhitelistConfiguration | null;
    enterpriseId: string;
    availableUsers: EmailWhitelistUserData[];
    availableEmailTypes: string[];
    onClose: () => void;
    form: ReturnType<typeof useWhitelistedUserEmailForm>;
}

export const WhitelistedUserEmailDialog = ({
    active,
    onClose,
    selectedRow,
    form,
    availableUsers,
    availableEmailTypes,
}: WhitelistedUserEmailDialogProps) => {
    const isEditing = selectedRow != null;

    const { submit, renderFormContent, isSubmitting } = form;

    return (
        <FloatingPanel
            active={active}
            onClose={onClose}
            title={lt(
                isEditing
                    ? TextKey.WhitelistedUserEmailsEditEmailDialogTitle
                    : TextKey.WhitelistedUserEmailsAddEmailDialogTitle
            )}
            footer={{
                primary: (
                    <Button variant="primary" type="button" size="medium" onClick={submit} disabled={isSubmitting}>
                        {isEditing ? TextKey.Save : TextKey.Create}
                    </Button>
                ),
                secondary: (
                    <Button variant="tertiary" type="button" size="medium" onClick={onClose}>
                        {lt(TextKey.Cancel)}
                    </Button>
                ),
            }}
        >
            {renderFormContent(
                <Stack spacing="200" vertical>
                    <EmailSelectField availableUsers={availableUsers} disabled={selectedRow != null} />
                    <EmailTypesSelectField availableEmailTypes={availableEmailTypes} />
                </Stack>
            )}
        </FloatingPanel>
    );
};
